import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { setLoggedIn } from "../Actions";
import { connect } from "react-redux";
import { toast } from "react-hot-toast";
import { useUsers } from "../UserContext";

function firebaseErrorMessage(code) {
  const messages = {
    'auth/user-not-found': 'No account found with that email.',
    'auth/wrong-password': 'Incorrect password.',
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-disabled': 'This account has been disabled.',
    'auth/operation-not-allowed': 'This sign-in method is not enabled — check Firebase Console → Authentication → Sign-in methods.',
    'auth/unauthorized-domain': 'This domain is not authorized in Firebase Console → Authentication → Settings → Authorized domains.',
    'auth/popup-closed-by-user': 'Sign-in popup was closed.',
    'auth/network-request-failed': 'Network error. Check your connection.',
    'permission-denied': 'Firestore permission denied — update your Firestore security rules in Firebase Console.',
  };
  return messages[code] || null;
}

const initialLogin = {
  email: "",
  password: "",
};

function Login(props) {
  const [user, setUser] = useState(initialLogin);
  const navigate = useNavigate();
  const { fetchUsers } = useUsers();

  function handleChange(e) {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  }

  async function login(e) {
    e.preventDefault();
    try {
      const res = await signInWithEmailAndPassword(auth, user.email, user.password);
      localStorage.setItem("user_id", res.user.uid);
      props.setLoggedIn();
      toast.success("Logged in successfully!");
      fetchUsers();
      navigate("/dashboard");
    } catch (err) {
      console.error("Login error:", err.code, err.message);
      const msg = firebaseErrorMessage(err.code) || err.message || "Login failed.";
      toast.error(msg);
    }
    setUser({ email: "", password: "" });
  }

  async function loginWithGoogle() {
    try {
      const provider = new GoogleAuthProvider();
      const res = await signInWithPopup(auth, provider);
      const uid = res.user.uid;

      const userDocRef = doc(db, 'users', uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        const displayName = res.user.displayName || '';
        const nameParts = displayName.split(' ');
        await setDoc(userDocRef, {
          uid,
          first_name: nameParts[0] || '',
          last_name: nameParts.slice(1).join(' ') || '',
          email: res.user.email || '',
          profile_pic_url: res.user.photoURL || '',
          city: '',
          state: '',
          country: '',
          bio: '',
        });
      }

      localStorage.setItem("user_id", uid);
      props.setLoggedIn();
      toast.success("Logged in with Google!");
      fetchUsers();
      navigate("/dashboard");
    } catch (err) {
      console.error("Google login error:", err.code, err.message);
      const msg = firebaseErrorMessage(err.code) || err.message || "Google login failed.";
      toast.error(msg);
    }
  }

  return (
    <div>
      <br></br>
      <br></br>
      <br></br>
      <h3 style={{padding: '20px'}}>Study the whole Bible with <b className="darkbrown">anointed music</b> and <b className="darkbrown">friends</b>.</h3>
      <h2>Login</h2>
      <form onSubmit={login}>
        <input
          required
          id="email"
          name="email"
          type="text"
          placeholder="Email"
          value={user.email}
          onChange={handleChange}
        />
        <br></br>
        <input
          required
          id="password"
          name="password"
          type="password"
          placeholder="Password"
          value={user.password}
          onChange={handleChange}
        />
        <br></br>
        <button id="login" className="login-button" type="submit">
          Login
        </button>
      </form>

      <br />
      <p style={{margin: '10px 0'}}>— or —</p>
      <button
        type="button"
        onClick={loginWithGoogle}
        style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '10px 20px',
          cursor: 'pointer',
          fontSize: '15px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          style={{ width: '18px', height: '18px' }}
        />
        Sign in with Google
      </button>

      <p id="noaccount">
        Don't have an account yet?
        <br></br>
        <Link className="link" to="/register">
          <h5 style={{textDecoration: 'underline'}}>Register for Free Here</h5>
        </Link>
      </p>
      <br />
      <br />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    loggedIn: state.loggedIn,
  };
};

export default connect(mapStateToProps, { setLoggedIn })(Login);
